import * as actionTypes from '../actions/actionsTypes';

const initialState = {
  seriesOTBList: {
    data: []
  },
};

export const seriesOTBListReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_SERIES_OTB_LIST:
      return {
        ...state,
        seriesOTBList: action.payload,
      };
    default:
      return state;
  }
};
